module.exports = __webpack_public_path__ + "static/media/white-logo-clock-in.abc04d64.png";